import Logo from "components/Logo/Logo";
import styled, { css } from "styled-components";

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterLogo = styled(Logo)`
  margin-right: 10px;
`;

export const InputsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const HorizonalDivider = styled.div`
  background: ${(props) => props.theme.divider};
  display: inline-flex;
  height: 1px;
  margin: 0 10px;
  width: 40px;
`;

export const UnitsWrapper = styled.div`
  position: absolute;
  text-align: center;
  left: 0;
  right: 0;
  color: ${({ theme }) => theme.textTertiary};
`;

export const WeightSearchFilterOverrides = css`
  min-width: 160px;
`;
